const link = (label, to, disabled = false) => ({ label, to, disabled });

export const footerNavigation = {
  creative: {
    title: "Brand & Creative",
    links: [
      link("Brand Strategy", "/services/brand-creative/branding/"),
      link("Brand Identity & Logo", "/services/brand-creative/logo-designing/"),
      link("Graphic Design", "/services/brand-creative/graphics-designing/"),
      link("UI/UX Design", "/services/brand-creative/ui-ux-designing/"),
      link("Packaging Design", "/services/brand-creative/packaging-design/"),
      link("Typography & Font Lab", "/typography/"),
      link("Custom Typeface Services", "/typography/custom-fonts/"),
      link("Explore Services", "/services/brand-creative/"),
    ],
  },
  growth: {
    title: "Digital Marketing",
    links: [
      link("Search Engine Optimization", "/services/digital-marketing/search-engine-optimization/"),
      link("Performance Ads (PPC)", "/services/digital-marketing/pay-per-click/"),
      link("Social Media Marketing", "/services/digital-marketing/social-media-marketing/"),
      link("Lead Generation", "/services/digital-marketing/lead-generation/"),
      link("CRM & Automation", "/services/ai-automation/crm-and-marketing-automation/"),
      link("Online Reputation (ORM)", "/services/production-offline/online-reputation-management/"),
      link("Explore Services", "/services/digital-marketing/"),
    ],
  },
  commerce: {
    title: "Commerce & Marketplaces",
    links: [
      link("Amazon Management", "/services/ecommerce-marketplace/amazon-account-management-services/"),
      link("Flipkart Management", "/services/ecommerce-marketplace/flipkart-account-management-services/"),
      link("Flipkart Marketing", "/services/ecommerce-marketplace/flipkart-marketing/"),
      link("Meesho Management", "/services/ecommerce-marketplace/meesho-account-management-services/"),
      link("Meesho Ecommerce Growth", "/services/ecommerce-marketplace/mesho-ecommerce-marketing/"),
      link("Ecommerce Development", "/services/ecommerce-marketplace/ecommerce-development/"),
      link("Explore Services", "/services/ecommerce-marketplace/"),
    ],
  },
  technology: {
    title: "Software Engineering",
    links: [
      link("Website Development", "/services/software-engineering/website-development/"),
      link("Mobile Applications", "/services/software-engineering/mobile-app-development/"),
      link("Desktop Applications", "/services/software-engineering/desktop-app-development/"),
      link("Website Maintenance", "/services/software-engineering/website-maintenance/"),
      link("Custom Web Apps", "/services/software-engineering/"),
      link("Explore Services", "/services/software-engineering/"),
    ],
  },
  automation: {
    title: "AI & Automation",
    links: [
      link("Workflow Automation", "/services/ai-automation/"),
      link("Cloud & DevOps", "/services/cloud-devops/"),
      link("Platform Integrations", "/services/integrations-enterprise/"),
      link("IoT & Smart Tech", "/services/emerging-tech-iot/"),
      link("Consulting & Strategy", "/services/consulting-transformation/"),
      link("Explore Services", "/services/ai-automation/"),
    ],
  },
  production: {
    title: "Production & Media",
    links: [
      link("Corporate Video Production", "/services/production-offline/video-production/"),
      link("Audio Loudness Analyzer", "/tools/audio-loudness-analyzer/"),
      link("Influencer Marketing", "/services/production-offline/influencer-marketing/"),
      link("Transit Banner Ads", "/services/production-offline/auto-riksha-banner-marketing/"),
      link("Commercial Photography", "/services/production-offline/commercial-photography/"),
      link("Backlit Signage Emulator", "/tools/design/backlit-signage-emulator/"), link("3D Exhibition Stand", "/tools/design/3d-exhibition-stand/"),
      // link("Trade Show & Events", "/services/production-offline/exhibition-event-branding/"),
      link("View All Services", "/services/"),
    ],
  },
  typography: {
    title: "Typography & Font Lab",
    links: [
      link("Typography Lab Hub", "/typography/"),
      link("Glyph Outline Inspector", "/typography/glyph-outline-inspector/"),
      link("Bézier Practice Studio", "/typography/bezier-curve-practice-studio/"),
      link("Kerning Pair Analyzer", "/typography/kerning-pair-analyzer/"),
      link("Proportion Analyzer", "/typography/letterform-proportion-analyzer/"),
      link("Composition Studio", "/typography/composition-challenge/"),
      link("Practice & Quiz Studio", "/typography/practice/"),
      link("Typeface ID Trainer", "/typography/typeface-identification-trainer/"),
      link("Letter Anatomy Lab", "/typography/letter-lab/"),
      link("Variable Fonts Lab", "/typography/variable-fonts/"),
      link("Modular Type Scale", "/typography/type-scale/"),
      link("Fluid Typography clamp()", "/typography/fluid-typography/"),
      link("Font Pairing Studio", "/typography/pairing/"),
      link("Typography Academy", "/typography/learn/"),
      link("Multilingual Font Viewer", "/resources/font-viewer/"),
      link("Custom Typeface Services", "/typography/custom-fonts/"),
      link("Project Scoping Brief", "/typography/project-brief/"),
    ],
  },
  industries: { title: "Industries", links: [link("Ecommerce & retail", "/industries/ecommerce-retail/"), link("B2B businesses", "/industries/b2b-businesses/"), link("Startups & SMEs", "/industries/startups-smes/"), link("Technology", "/industries/technology/"), link("Consumer brands", "/industries/consumer-brands/"), link("Explore Industries", "/industries/")] },
  platforms: { title: "Platforms", links: [link("Google & search", "/services/digital-marketing/search-engine-optimization/"), link("Meta & social", "/services/digital-marketing/social-media-marketing/"), link("Amazon", "/services/ecommerce-marketplace/amazon-account-management-services/"), link("Flipkart", "/services/ecommerce-marketplace/flipkart-account-management-services/"), link("Meesho", "/services/ecommerce-marketplace/meesho-account-management-services/"), link("Platform services", "/services/")] },
  resources: { title: "Resources", links: [link("Typography Lab Hub", "/typography/"), link("Audio Loudness Analyzer", "/tools/audio-loudness-analyzer/"), link("Glyph Outline Inspector", "/typography/glyph-outline-inspector/"), link("Bézier Curve Studio", "/typography/bezier-curve-practice-studio/"), link("Digital tools", "/tools/"), link("3D Exhibition Stand", "/tools/design/3d-exhibition-stand/"),
      link("Packaging Studio", "/tools/design/packaging-studio/"), link("Design Distance Visualizer", "/tools/design/design-distance-visualizer/"), link("Blog & insights", "/blog/"), link("Explore resources", "/tools/")] },
  company: { title: "Company", links: [link("Portfolio", "/portfolio/"), link("Contact Goafreet", "/contact-support/"), link("Start a project", "/contact-support/"), link("Our services", "/services/")] },
  support: { title: "Support", links: [link("Contact support", "/contact-support/"), link("Project enquiry", "/contact-support/"), link("Request a call", "/contact-support/"), link("Website feedback", "/contact-support/")] },
  legal: { title: "Legal", links: [link("Privacy policy", "/legal/privacy-policy/"), link("Terms of use", "/legal/terms-of-use/"), link("Service terms", "/legal/service-terms/"), link("Usage rules", "/legal/service-usage-rules/"), link("Performance disclaimer", "/legal/performance-disclaimer/"), link("NDA & confidentiality", "/legal/nda-confidentiality/"), link("Responsible outreach", "/legal/responsible-outreach/"), link("All legal policies", "/legal/")] },
};

export const serviceCategories = ["creative", "growth", "commerce", "technology", "automation", "production"];
export const secondaryFooterCategories = ["typography", "resources", "industries", "platforms", "company", "legal"];
